module.exports = __webpack_public_path__ + "static/street3-809af8a8d9c209e6491c3fbc678e141e.jpg";